// extracted by mini-css-extract-plugin
module.exports = {"goftion-section":"GoftinoSection_goftion-section__r6Gap","goftino-close":"GoftinoSection_goftino-close__9mZtt","goftino-content":"GoftinoSection_goftino-content__exaPN"};